import { call, take, put, fork, all } from 'redux-saga/effects';
import { TransformObject } from 'src/utils/serialization';
import { StaticToast } from 'src/components/common';
import { DepartmentActionTypes } from './type';
import { fetchJson } from 'src/utils/fetch';

function* fetch_department_list() {
  while (true) {
    const action = yield take(DepartmentActionTypes.FETCH_DEPARTMENT_LIST);
    try {
      const { onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/hostpital/departmentList', 
        type: 'POST', 
        action,
        needLogin: false,
        isloading: false,
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        typeof onSuccess === 'function' && onSuccess();
        if(result.length){
          result.forEach(item => {
            if(item.departmentCode === '03.07'){
              item.departmentName = '糖尿病专区';
            }
          });
        }
        const department_obj = TransformObject(result, 'departmentCode', 'departmentName');
        yield put({ type: DepartmentActionTypes.FETCH_DEPARTMENT_LIST_SUCCESS, data: {list: result, obj: department_obj} });
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error(`fetch_department_list--------${JSON.stringify(error)}`);
    }
  }
}

export default function* root() {
  yield all([
    fork(fetch_department_list)
  ])
}